// @flow

import {
  initialState,
} from 'hfty-operator-contact-us'

export default {
  ...initialState,
}
